import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CheckIcon from '@mui/icons-material/Check';

function Card(props) {
  return (
    <div
      className={`bg-white border px-4 py-4 max-w-sm rounded-xl overflow-hidden h-80 w-96
                 transition-shadow duration-300 hover:shadow-md hover:shadow-green-100 cursor-pointer group relative
                 ${props.isSelected ? 'border-green-800' : 'border-gray-100'}`}
      onClick={props.onClick}
    >
      <div className="absolute top-3 right-3">
        <div
          className={`w-6 h-6 rounded-md flex items-center justify-center shadow
                      ${props.isSelected ? 'bg-green-800 text-white' : 'bg-white border border-gray-300'}`}
        >
          {props.isSelected && <CheckIcon style={{ fontSize: 16 }} />}
        </div>
      </div>

      <div className="text-gray-800 group-hover:text-green-700">
        {props.icon}
      </div>

      <div className="text-xl font-bold mt-4 text-gray-900 group-hover:text-green-700">
        {props.title}
      </div>

      <div className="text-gray-600 mt-2">
        {props.detail}
      </div>

      <div className="text-lg text-green-800 mt-6 flex items-center gap-1 bottom-4 absolute">
        {props.title} <ArrowForwardIcon />
      </div>
    </div>
  );
}

export default Card;
